/**
 * ホットライン申し込み日程ステータス: 未設定
 */
export const HOTLINE_INTERVIEW_STATUS_UNSET = {
    label: '未設定',
    value: 1,
};
/**
 * ホットライン申し込み日程ステータス: 拒否
 */
export const HOTLINE_INTERVIEW_STATUS_BLOCK = {
    label: '拒否',
    value: 2,
};
/**
 * ホットライン申し込み日程ステータス: 受諾
 */
export const HOTLINE_INTERVIEW_STATUS_ACCEPT = {
    label: '受諾',
    value: 3,
};
/**
 * ホットライン申し込み日程ステータス: 完了
 */
export const HOTLINE_INTERVIEW_STATUS_COMPLETED = {
    label: '完了',
    value: 4,
};
/**
 * ホットライン申し込み日程ステータス 一覧
 */
export const HOTLINE_INTERVIEW_STATUS = [
    HOTLINE_INTERVIEW_STATUS_UNSET,
    HOTLINE_INTERVIEW_STATUS_BLOCK,
    HOTLINE_INTERVIEW_STATUS_ACCEPT,
    HOTLINE_INTERVIEW_STATUS_COMPLETED,
];
